<template>
    <div class="honorDetail main-flex px-350">
        <div class="title hidden-xs-only">
            <h1>{{yyMessage}}</h1>
            <hr>
        </div>
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
        <div class="imgLimit"><img :src="wWidth<768?img[1]:img[0]" alt=""></div>
        <el-row :gutter="12" style="flex-wrap:wrap">
            <!-- <el-col :xs="24" :sm="12" :md="8" v-for="(item,index) in img.slice(1)" :key="index" style="margin-bottom:10px"> -->
            <el-col :span="8" v-for="(item,index) in img.slice(2)" :key="index" style="margin-bottom:10px">
                <div class="imgLimit2"><img :src="item" alt=""></div>
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import XSTitle from '../eyTitXs.vue'
export default {
    data(){
        return{
            yyMessage: '资质展示',
            titEN: 'QUALIFICATION DISPLAY',
            img:[require('@/assets/abHonor.png'),
            require('@/assets/phone/abHonor.png'),
            require('@/assets/abH1.png'),
            require('@/assets/abH2.png'),
            require('@/assets/abH3.png')],
            wWidth : window.screen.width
        }
    },
    components:{
        XSTitle
    }
}
</script>

<style lang="scss" scoped>
.honorDetail{
    flex-direction: column;
    padding-top: vw(50);
    padding-bottom: vw(70);

    .title{
        position: relative;
        
        h1{
            display: inline-block;
            font-size: vw(30);
            margin: 0;
            padding: vw(20) vw(44);
            color: $font23;
            letter-spacing: vw(10);
            background: white;
            border: 2px solid $grayF2;
            border-radius: 5px;
        }

        hr{
            position: absolute;
            top: 50%;
            left: 0;
            // width: vw(1201);
            width: 100%;
            height: 2px;
            background-color: $grayF2;
            margin: 0;
            border: 0;
            z-index: -1;
        }
    }

    .imgLimit,
    .imgLimit2{
        img{
            width: 100%;
            height: 100%;
        }
    }

    .imgLimit{
        width: vw(1213);
        height: vw(174);
        margin: vw(51) 0 vw(30);
    }

    .imgLimit2{
        max-width: vw(368);
        height: vw(235);
        display: inline;
    }

    // -------------------------------  手机端  -------------------------------

    @media only screen and (max-width: 767px){
        padding-top: vp(50);

        .imgLimit{
            width: vp(689);
            height: vp(381);
            margin: 0 0 vp(20);
        }
    }
}
</style>